const AM = 'AM';
const PM = 'PM';
const DAY_MIDDLE = 12;
const DEFAULT_PADDING_LENGTH = 2;
const DEFAULT_PADDING_STRING = '0';

/**
 * Function to pad a string|number with leading string
 * @param {string|number} str current string|number
 * @param {number} len length of the resulting string once the current string has been padded
 * @param {string} chr the string to use for padding
 * @returns {string}
 */
const padLeft = (str, len = DEFAULT_PADDING_LENGTH, chr = DEFAULT_PADDING_STRING) => `${str}`.padStart(len, chr);

/**
 * Returns time in "hh:mm A" format
 * @param {Date} date
 * @returns {string}
 */
const formatAMPMTime = (date) => {
  let hours = date.getHours();
  const minutes = padLeft(date.getMinutes());
  const ampm = hours >= DAY_MIDDLE ? PM : AM;
  hours = hours % DAY_MIDDLE;
  hours = hours ? hours : DAY_MIDDLE;
  return hours + ':' + minutes + ' ' + ampm;
}

/**
 * Returns date in "YYYY/MM/DD" format
 * @param {Date} date
 * @returns {string}
 */
const formatSlashedDate = (date) => {
  return [date.getFullYear(), padLeft(date.getMonth()+1), padLeft(date.getDate())].join('/');
}

export {formatAMPMTime, formatSlashedDate};
